import { LinkButton } from 'shared/components';
import { CardAuthorizationsTable } from '../CardAuthorizationsTable/CardAuthorizationsTable';
import { Alert, Col, Row } from 'react-bootstrap';
import { Movimiento } from 'core/tarjeta/models/Movimiento';
import { Pageable } from 'shared/table/models/Pageable';

export const CardAuthorizationsList = (props: {
  authorizations: Pageable<Movimiento>;
  goBack(): void;
}) => {
  return (
    <>
      <Alert>
        Estos movimientos corresponden a consumos autorizados pendientes de presentación
        por parte del establecimiento. Los mismos se consideran para calcular el
        disponible de la tarjeta.
      </Alert>
      <CardAuthorizationsTable authorizations={props.authorizations.content} />
      <Row>
        <Col className="text-center">
          <LinkButton onClick={props.goBack}>Movimientos para la tarjeta</LinkButton>
        </Col>
      </Row>
    </>
  );
};
